// Copyright 2016 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { IAuthentication } from "libraries/Authentication/IAuthentication";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { Repository } from "repositories/Repository";

@autoinject
export class AccountRepository extends Repository {
    private soramaBusinessUnitId: string;

    constructor(
        private readonly webRequestHandler: IWebRequestHandler,
        private readonly authentication: IAuthentication
    ) {
        super();
    }

    //#region GetRequests
    public getSoramaBusinessUnitId(): Promise<string> {
        if (this.soramaBusinessUnitId) {
            return Promise.resolve(this.soramaBusinessUnitId);
        } else {
            return this.webRequestHandler
                .createGetRequest<string>(Api.account + "/SoramaBusinessUnitId")
                .send()
                .then((x) => (this.soramaBusinessUnitId = x.content))
                .catch((e) => this.onError(e));
        }
    }

    public getBusinessUnitId(): Promise<string> {
        const request = this.webRequestHandler.createGetRequest<string>(Api.account + "/BusinessUnitId");

        return request
            .send()
            .then((x) => x.content)
            .catch((e) => this.onError(e));
    }

    //#endregion

    //#region PostRequests
    public resetPasswordRequest(): Promise<void> {
        return this.authentication.getUser().then(() => {
            return this.webRequestHandler
                .createPutRequest(Api.userManager + "/" + this.authentication.userId + "/passwordReset")
                .send()
                .then(() => {});
        });
    }

    //#endregion

    //#region Put Collections Requests

    //#endregion

    //#region Delete Requests

    //#endregion
}
